<template>
  <v-app>
   <v-navigation-drawer
      fixed
      v-model="drawerRight"
      right
      clipped
      app
      class="hidden-md-and-down"
    >
    </v-navigation-drawer>
    <v-navigation-drawer
      v-model="isOpenSideBar"
      fixed
      clipped
      app
    >
      <v-btn class="nav-close-btn hidden-md-and-up"  @click.stop="setOpenSideBar(false)">닫기</v-btn>
    <div id="nav">
      <side-bar  @click.stop="isOpenSideBar = !isOpenSideBar"></side-bar>
    </div>
    </v-navigation-drawer>
    <v-toolbar app dark fixed clipped-left clipped-right color="blue darken-3">
      <v-toolbar-side-icon @click.stop="setOpenSideBar(!isOpenSideBar)"></v-toolbar-side-icon>
     <v-toolbar-title class="mr-5 align-center">
        <span class="restaurant-title">
          
          {{selectRestaurantName}}
          <div style="width:10px"></div>
          <img v-if="selectRestaurant === null" src="./assets/foodicon.png" width="32">
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-toolbar-side-icon @click.stop="drawerRight = !drawerRight"><v-icon>update</v-icon></v-toolbar-side-icon> -->
      <v-btn v-if="isAuthenticated==false" @click="loginPressed">로그인</v-btn>
      <v-btn v-if="isAuthenticated"  @click="logoutPressed">로그아웃</v-btn>
      <v-btn color="white" light @click="showOpenchatRoom">채팅 상담</v-btn>

    </v-toolbar>
    <v-content fluid >
      <v-layout >
        <router-view></router-view>
      </v-layout>
    </v-content>
    <v-dialog v-model="loginDialog" width="600px">
      <login-modal :dialog.sync="loginDialog" :singupDialog.sync="singupDialog"></login-modal>
    </v-dialog>
    <v-dialog v-model="singupDialog" width="600px">
      <SignUpModal :dialog.sync="singupDialog"></SignUpModal>
    </v-dialog>
  </v-app>
</template>

<script>
import SideBar from "./views/SideBar.vue";
import store from "@/store.js";
import LoginModal from "@/components/LoginModal";
import SignUpModal from "@/components/SignUpModal";

export default {
  name: "app",
  store,
  components: {
    SideBar,
    LoginModal,
    SignUpModal
  },
  data: () => ({
    // drawer: true,
    drawerRight: false,
    right: true,
    loginDialog: false,
    singupDialog: false,
    
  }),
  computed: {
    selectRestaurant: function() {
      return this.$store.state.selectRestaurant;
    },
    isOpenSideBar: function(){
      return this.$store.state.isOpenSideBar;
    },
    selectRestaurantName: function() {
      let restaurant = this.selectRestaurant;
      if (restaurant === undefined || restaurant === null)
        return "구내식당 APP";
      return restaurant.nm;
    },
    isAuthenticated: function() {
      return this.$store.getters.isAuthenticated;
    }
  },
  methods: {
    loginPressed: function() {
      this.loginDialog = true;
    },
    setOpenSideBar: function(value){
 
      this.$store.commit('setOpenSideBar', value)
    },
    logoutPressed: function() {
      alert("로그아웃 되었습니다");
      this.$store.commit("logout");
    },
    showOpenchatRoom: () => {
      // alert("showOpenchatRoom");
      window.open("https://open.kakao.com/o/gUPG3e1", "_blank");
    }    
  },
  mounted: {
    //auth check
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.restaurant-title {
  display: flex;
  align-items: center;
}
</style>
